import styled from "styled-components";

export const SidenavWrapper = styled.div`
  width: 20%;
  height: 100vh;
  background: #22406d;
  overflow: hidden;
  padding: 48px 0px 16px 16px;
  position: relative;
  @media only screen and (min-width: 1300px) {
    width: 250px;
  }
`;

export const ImageWrapper = styled.div`
  margin-bottom: 60px;
  cursor: pointer;
`;

export const NavItem = styled.div`
  display: flex;
  margin-bottom: 16px;
  & .icon {
    margin-right: 12px;
  }
  cursor: pointer !important;
`;

export const StyledLink = styled.span`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #ffffff;
  opacity: ${(props: { active?: boolean }) => (props.active ? "1" : "0.6")}; ;
`;

export const LogoutBtn = styled(StyledLink)`
  opacity: 1;
`;

export const Name = styled(StyledLink)`
  font-weight: 400;
  opacity: 0.5;
`;

export const LogoutBox = styled.div`
  position: absolute;
  bottom: 20px;
`;

export const SidenavLogo = styled.img`
  width: 150px;
`;
